import { identity } from 'ramda';
import { useEffect, useCallback, useReducer, useState } from 'react';
import { workerService } from 'js/services/worker.service';

import { reducer } from './store/reducer';
import * as actions from './store/actions';

export const defaultParse = identity;

export const useDataFetch = ({
    fetch,
    params = null,
    onResponse = defaultParse,
    onError = identity,
    initialData,
    initialIsLoading = true,
    shouldFetch = undefined
}) => {
    const [correlation, setCorrelation] = useState();
    const [fetchParams, setFetchParams] = useState(params);
    const doFetch = useCallback((par, corr) => {
        setFetchParams(par);
        setCorrelation(corr);
    }, [setFetchParams, setCorrelation]);
    const [state, dispatch] = useReducer(reducer, {
        isLoading: initialIsLoading,
        error: null,
        data: initialData
    });

    useEffect(() => {
        let didUnmount = false;

        if (shouldFetch && !shouldFetch(fetchParams)) {
            return;
        }

        dispatch({ type: actions.FETCH_INIT });

        (async () => {
            try {
                const response = typeof fetch === 'string'
                    ? await workerService.request(fetch, fetchParams)
                    : await fetch(fetchParams);

                if (!didUnmount) {
                    dispatch({ type: actions.FETCH_SUCCESS, payload: onResponse(response, correlation) });
                }
            } catch (err) {
                const legacyError = err.response ?? err.request ?? err;

                if (!didUnmount) {
                    dispatch({ type: actions.FETCH_FAILURE, payload: onError(legacyError, correlation) });
                }
            }
        })();

        return () => {
            didUnmount = true;
        };
    }, [fetchParams, correlation, fetch, onResponse, onError, dispatch, shouldFetch]);

    return [state, doFetch];
};
